import { Close, SwipeArrow, VolumeControlIcon } from '../icons'
import {
  CenterPlayButton,
  Overlay,
  OverlayCloseButtonItem,
  OverlayInfo,
  OverlayLeftButtonsWrap,
  OverlayTopButtonsWrap,
  PlayerLinkInline,
  PlayerTipNextButton,
  PlayerTitle,
  PlayerTitleLinkRow,
  VideoTime,
} from './PlayerOverlay.style'
import { PlayerLink, TitleEpisodeComp } from '../ItemComponents'
import { PlayIcon } from '../icons'
import { IPlayerStyle } from '../type'
import { usePlayer } from '../PlayerContext'
import { ShareIcon } from '../icons/Share'
import { isDesktop } from '../../../../client'
import { reelsHe } from '../../../../locales/reels.he'
import { useGridBlock } from '../../../../contexts'

interface IPlayerOverlayProps {
  handleMute: () => void
  playerStyle: IPlayerStyle
  index: number
  realIndex: number
  isNextVideoTip: boolean
  handleClosePlayer: () => void
  timelineItemTime?: string
  titleHeader: string
  link?: string
  link_title?: string
  title: string
  episode?: number
  handlePressPlayerLink: () => void
  /** RESH13-1138 - only used when playerStyle.showCenterPlayButton is on */
  isPaused?: boolean
  handleTogglePlay?: () => void
  /**
   * RESH13-1138 - during a pre-roll the video's own description has no business
   * being on screen: it belongs to the content, not to the ad playing over it.
   */
  isAdPlaying?: boolean
}
export const PlayerOverlay = ({
  handleMute,
  playerStyle,
  index,
  realIndex,
  isNextVideoTip,
  handleClosePlayer,
  timelineItemTime,
  titleHeader,
  link,
  link_title,
  handlePressPlayerLink,
  title,
  episode,
  isPaused,
  handleTogglePlay,
  isAdPlaying,
}: IPlayerOverlayProps) => {
  const { isMuted, isMiniSeries } = usePlayer()
  const { gridId } = useGridBlock()
  const handleShare = (e: {
    preventDefault: () => void
    stopPropagation: () => void
  }) => {
    e.preventDefault()
    e.stopPropagation()
    const url = `${window.location.origin}${window.location.pathname}?vpanchor=${gridId}-${realIndex}`
    if (!isDesktop() && navigator.share) {
      navigator
        .share({
          title,
          url,
        })
        .catch(err => {
          console.warn('Share cancelled or failed:', err)
        })
    } else {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          alert('הקישור הועתק בהצלחה!')
        })
        .catch(() => {
          console.warn('העתקת הקישור נכשלה')
        })
    }
  }

  return (
    <Overlay
      theme={playerStyle}
      showNextVideoTip={index === 0 && isNextVideoTip}
    >
      <OverlayTopButtonsWrap>
        <OverlayCloseButtonItem
          type='button'
          aria-label={reelsHe.close}
          onClick={handleClosePlayer}
          className={'close'}
          iconSize={playerStyle.controlIconSize}
        >
          <Close />
        </OverlayCloseButtonItem>
        {!isMiniSeries && (
          <OverlayCloseButtonItem
            type='button'
            aria-label={isMuted ? reelsHe.unmute : reelsHe.mute}
            onClick={handleMute}
            iconSize={playerStyle.controlIconSize}
          >
            <VolumeControlIcon isMuted={isMuted} />
          </OverlayCloseButtonItem>
        )}
      </OverlayTopButtonsWrap>
      {playerStyle.showCenterPlayButton && isPaused && (
        <CenterPlayButton
          type='button'
          aria-label={reelsHe.play}
          onClick={handleTogglePlay}
        >
          <PlayIcon />
        </CenterPlayButton>
      )}
      <OverlayInfo theme={playerStyle} hidden={isAdPlaying}>
        {isMiniSeries && (
          <OverlayLeftButtonsWrap>
            <OverlayCloseButtonItem
              type='button'
              aria-label={reelsHe.share}
              onClick={handleShare}
            >
              <ShareIcon />
            </OverlayCloseButtonItem>
            <OverlayCloseButtonItem
              type='button'
              aria-label={isMuted ? reelsHe.unmute : reelsHe.mute}
              onClick={handleMute}
            >
              <VolumeControlIcon isMuted={isMuted} />
            </OverlayCloseButtonItem>
          </OverlayLeftButtonsWrap>
        )}
        {timelineItemTime && titleHeader && (
          <VideoTime>
            <span>
              {titleHeader} | {timelineItemTime}
            </span>
          </VideoTime>
        )}
        {link && timelineItemTime ? (
          <PlayerTitleLinkRow>
            <PlayerTitle
              timelineItemTime={timelineItemTime}
              isMiniSeries={isMiniSeries}
              titleFontSize={playerStyle.titleFontSize}
            >
              {title}
            </PlayerTitle>
            <PlayerLinkInline href={link} onClick={handlePressPlayerLink}>
              לטיימליין המלא
            </PlayerLinkInline>
          </PlayerTitleLinkRow>
        ) : (
          <>
            {isMiniSeries && <TitleEpisodeComp ep={episode} />}
            <PlayerTitle
              timelineItemTime={timelineItemTime}
              isMiniSeries={isMiniSeries}
              titleFontSize={playerStyle.titleFontSize}
            >
              {title}
            </PlayerTitle>
            <PlayerLink
              link={link}
              link_title={link_title}
              handlePressPlayerLink={handlePressPlayerLink}
            />
          </>
        )}
      </OverlayInfo>
      {index === 0 && isNextVideoTip && (
        <PlayerTipNextButton mobileOnly={true}>
          <SwipeArrow />
          <p>לסרטון הבא</p>
        </PlayerTipNextButton>
      )}
    </Overlay>
  )
}
